import InlineSVG from "react-inlinesvg";
import { ContinuityCardContainer } from "./styles.js";

export default function ContinuityCard({ onClose }) {
  const handleShowMeClick = (e) => {
    e.preventDefault();
    // Open the changelog in a new tab
    window.open("https://feedback.sudowrite.com/changelog/better-narrative-consistency-with-chapter-continuity", "_blank");
  };
  return (
    <ContinuityCardContainer>
      <InlineSVG
        src="/assets/close.svg"
        className="close"
        onClick={(event) => {
          event.stopPropagation();
          onClose();
        }}
      />
      <div className="resources-title">
        <div className="resources-title-new"> New</div>
        <div className="resources-title-text">Write & Draft Upgraded</div>
        <div className="resources-description">
          Now they'll use your <em>entire</em> manuscript for much better consistency.
        </div>
      </div>
      <div className="resources-container">
        <a
          className="resource"
          target="_blank"
          href="#"
          onClick={handleShowMeClick}
        >
          Learn More
        </a>
      </div>
    </ContinuityCardContainer>
  );
}
